<h4>Selectionnez votre profil</h4>
<mat-nav-list>
  <div *ngFor="let item of societyList; let i = index" >
   <a mat-list-item (click)="openLink(item.companyGuid)">{{item.name}}</a>
   </div>
</mat-nav-list>